export const turnkeyIntegrations = (state) => state.turnkey.integrations;
export const turnkeySdkInstance = (state) => state.turnkey.sdkInstance;
export const turnkeyIsLoading = (state) => state.turnkey.isLoading;
